// Human-readable channel names for the contact detail screen ("hace 2 h ·
// WhatsApp", "Ventas · WhatsApp"). Keys are the Rails channel class names
// that come back in `inbox.channel_type` / `conversation.meta.channel`.
const CHANNEL_LABELS = {
  'Channel::Whatsapp': 'WhatsApp',
  'Channel::Evolution': 'WhatsApp QR',
  'Channel::TwilioSms': 'SMS',
  'Channel::Sms': 'SMS',
  'Channel::Instagram': 'Instagram',
  'Channel::Email': 'Email',
  'Channel::FacebookPage': 'Facebook',
  'Channel::WebWidget': 'Web',
  'Channel::Telegram': 'Telegram',
  'Channel::Line': 'LINE',
  'Channel::Api': 'API',
  'Channel::Voice': 'Voz',
};

export const channelLabel = channelType => {
  if (!channelType) return '';
  return (
    CHANNEL_LABELS[channelType] || String(channelType).replace(/^Channel::/, '')
  );
};

// Fixed hexes (same as the mockup) for the per-channel dots used on the
// conversation list of the contact detail.
const CHANNEL_DOT_HEX = {
  'Channel::Whatsapp': '#1b8f7f',
  'Channel::Evolution': '#1b8f7f',
  'Channel::TwilioSms': '#1b8f7f',
  'Channel::Sms': '#1b8f7f',
  'Channel::Instagram': '#c05a45',
  'Channel::Email': '#3b7fc4',
  'Channel::FacebookPage': '#5b5bd6',
  'Channel::WebWidget': '#b58218',
};

export const channelDotHex = channelType =>
  CHANNEL_DOT_HEX[channelType] || '#93a2ae';
